import { Button, Wrap } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage } from "react-intl";
import NextLink from "next/link";

function ContactAndSubscribe() {
  return (
    <Wrap justify="flex-end" spacing="1rem">
      <NextLink href={generateFrontPath({ id: "@contact" })} passHref>
        <Button
          as="a"
          height="52px"
          width="145px"
          borderRadius="full"
          variant="outline"
          colorScheme="brandSecondary">
          <FormattedMessage defaultMessage="Contact" />
        </Button>
      </NextLink>

      <NextLink
        href={generateFrontPath({
          id: "@account.prestations.search",
        })}
        passHref>
        <Button
          as="a"
          height="52px"
          width="145px"
          borderRadius="full"
          colorScheme="brandSecondary">
          <FormattedMessage defaultMessage="M'inscrire" />
        </Button>
      </NextLink>
    </Wrap>
  );
}

export default ContactAndSubscribe;
